import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "./BillingDetailsContainer";

export const EmailHubBanner = () => (
  <BillingDetailsContainer>
    <Typography.LabelMd>
      {t("settings.billing.manage_billing.email_hub_banner.title")}
    </Typography.LabelMd>
  </BillingDetailsContainer>
);
